import angular from 'angular';
import ConstantsService from "./constants/constants";
import AuthenticationService from './authentication/authentication'
import SettingsService from './settings/settings'
import CompanyService from "./company/company";
import DashboardService from "./dashboard/dashboard";
import TravelExpenseService from './travel-expenses/travel-expenses'
import InvoiceService from './invoices/invoices'

let serviceModule = angular.module('app.services', [
  ConstantsService.name,
  AuthenticationService.name,
  SettingsService.name,
  CompanyService.name,
  DashboardService.name,
  TravelExpenseService.name,
  InvoiceService.name,
]);

export default serviceModule;



// WEBPACK FOOTER //
// ./client/common/services/services.js